import React, { useState, useEffect } from 'react';
import './AILoadingState.css';

const AILoadingState = ({
  messages = [
    "Analyzing user's skill profile...",
    "Comparing required skills with user expertise...",
    "Evaluating task complexity...",
    "Calculating personalized estimates...",
    "Generating recommendations..."
  ],
  interval = 8000
}) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentMessageIndex((prevIndex) =>
        (prevIndex + 1) % messages.length
      );
    }, interval);

    return () => clearInterval(timer);
  }, [messages.length, interval]);

  return (
    <div className="ai-loading-container">
      <div className="ai-loading-spinner"></div>
      <p className="ai-loading-message">{messages[currentMessageIndex]}</p>
    </div>
  );
};

export default AILoadingState;
